import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import useElementOnScreen from "../common/customHooks/useElementOnScreen";
import muteIcon from "../../assets/images/icons/mute-icon.svg";
import unmuteIcon from "../../assets/images/icons/unmute-icon.svg";
import { analyticsEvent, eventName } from "../common/Analytics/AnalyticsEvent";
import { fetchCurrentState } from "../../redux/features/customerViewSlice";
import { useSelector } from "react-redux";
import { getCurrencySymbol } from "../../util";

export default function VideoSlides({ isMuted, setisMuted, media }) {
  // pass itMuted and setisMuted as props from parent Component for single click mute
  // const [isMuted, setisMuted] = useState(true)
  const tripStateData = useSelector(fetchCurrentState);

  // console.log('VideoCarousel>>> :: Rendered')

  function storageMuteState(isMuted) {
    localStorage.setItem("introMuteState", isMuted);
  }

  const [isVideoPlaying, setisVideoPlaying] = useState(false);

  const videoRef = useRef(null);
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.7,
  };
  const isVisibile = useElementOnScreen(options, videoRef);

  useEffect(() => {
    // window.addEventListener("resize", handleResize)

    if (isVisibile) {
      if (!isVideoPlaying) {
        const promise = videoRef.current.play();
        // console.log(videoRef)
        promise
          .then(() => {
            setisVideoPlaying(true);
          })
          .catch((error) => {
            setisVideoPlaying(false);
          });
      }
    } else {
      if (isVideoPlaying) {
        // videoRef.current.pause();
        videoRef.current.pause();
        setisVideoPlaying(false);
      }
    }
    storageMuteState(isMuted);
  }, [isVisibile]);

  // const onVideoClick = () => {
  //   // console.log(isVideoPlaying)
  //   // if (isVideoPlaying) {
  //   //   videoRef.current.pause()
  //   //   setisVideoPlaying(!isVideoPlaying)
  //   // } else {
  //   //   videoRef.current.play()
  //   //   setisVideoPlaying(!isVideoPlaying)
  //   // }
  //   if (props.isMuted) {
  //     props.setisMuted(false)
  //   } else {
  //     props.setisMuted(true)
  //   }
  // }

  const muteHandle = () => {
    if (isMuted) {
      analyticsEvent.clickEvent(
        "Intro",
        eventName.Intro_unmute,
        `TripName: ${tripStateData.display_name}, id: ${
          tripStateData.item_id
        }, duration: ${
          tripStateData.properties.trip_summary.duration_days
        }, price: ${
          getCurrencySymbol(tripStateData.properties.price[0].unit) +
          tripStateData.properties.price[0].value
        }`
      );
      storageMuteState((isMuted = false));
      setisMuted(false);
    } else {
      analyticsEvent.clickEvent(
        "Intro",
        eventName.Intro_mute,
        `TripName: ${tripStateData.display_name}, id: ${
          tripStateData.item_id
        }, duration: ${
          tripStateData.properties.trip_summary.duration_days
        }, price: ${
          getCurrencySymbol(tripStateData.properties.price[0].unit) +
          tripStateData.properties.price[0].value
        }`
      );
      storageMuteState((isMuted = true));
      setisMuted(true);
    }
  };

  return (
    <div style={{ position: "relative" }} onClick={muteHandle}>
      <video
        ref={videoRef}
        src={media.videoUrl}
        // autoPlay={true}
        muted={isMuted}
        // onPlaying={() => {
        //   console.log('played::', props.index)
        // }}
        poster={media.videoThumbnail}
        style={{
          width: "100%",
          height: "100vh",
          objectFit: "cover",
        }}
        loop
        playsInline
      ></video>
      <img
        src={isMuted ? muteIcon : unmuteIcon}
        alt="mute-icon"
        className={!isMuted && "fade-out-icon"}
        style={
          // isMuted
          // ?
          {
            position: "absolute",
            top: "44%",
            left: "50%",
            transform: "translate(-50%, -44%)",
            zIndex: "2",
            width: "55px",
            height: "auto",
            cursor: "pointer",
          }
          // : { display: 'none' }
        }
      ></img>
    </div>
  );
}
